import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.branchList}?organisation=${id}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On branches get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* patch(action) {
    const { branch } = action.payload;
    const { id } = yield select((state) => state.userOrganisations.item);
    const url = `${config.api.paths.branches}${branch.id}/?organisation=${id}`;
    try {
        const { data } = yield call(http.authorized.patch, url, branch);
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On branches patch:", { error });
        yield put(actionCreators.patchFailure(error));
    }
}

function* post(action) {
    const { branches } = action.payload;
    const { id } = yield select((state) => state.userOrganisations.item);
    const url = `${config.api.paths.branchBulkUpdate}/?organisation=${id}`;
    try {
        const { data } = yield call(
            http.authorized.post,
            url,
            branches.map((item) => {
                return { ...item, organisation: id };
            })
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On branches post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.BRANCHES_GET_REQUEST, get),
        takeLatest(actionTypes.BRANCHES_POST_REQUEST, post),
        takeLatest(actionTypes.BRANCH_PATCH_REQUEST, patch)
    ]);
}
